import React, { useRef, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import contractService from '../../services/ContractService';
import "./css/Upload.css";

const Upload = ({ contract, show, onClose }) => {
    const fileInputRef = useRef();
    const fileProjectInputRef = useRef();
    const { register,control,setValue, watch } = useForm();

    const [message, setMessage] = useState(null);
    const [errorMsg, setErrorMsg] = useState(null);
    const [uploadSignedOK, setUploadSignedOK] = useState(false);
    const [uploadProjectOK, setUploadProjectOK] = useState(false);

    const closeSlide = () => {
        setUploadSignedOK(false);
        setUploadProjectOK(false);
        setErrorMsg(null);
        setMessage(null);
        onClose();
    };

    const uploadSignedPdf = async (file) => {
        const formData = new FormData();
        formData.append('file', file);
        formData.append("contractId", contract.id_contract);
        if (contract) {
            contractService.upload(formData)
            .then((res) => {
               setMessage("File contratto aggiunto con successo!");
               setErrorMsg("");
               setUploadSignedOK(true);
            }).catch((error) => {
                console.error("Error add file: ", error);
                setMessage("");
                setUploadSignedOK(false);
                setErrorMsg("Errore aggiunta file contratto. Riprova.");
            });
        }
    };
    const uploadProjectPdf = async (file) => {
        const formData = new FormData();
        formData.append('file', file);
        formData.append("contractId", contract.id_contract);
        if (contract) {
            contractService.uploadProject(formData)
            .then((res) => {
               setMessage("File progetto aggiunto con successo!");
               setErrorMsg("");
               setUploadProjectOK(true);
            }).catch((error) => {
                console.error("Error add file: ", error);
                setMessage("");
                setUploadProjectOK(false);
                setErrorMsg("Errore aggiunta file progetto. Riprova.");
            });
        }
    };

    const validateAndUpload = (file, fieldName, uploadFn) => {
        if (!file) return;

        if (file.type !== "application/pdf") {
            setErrorMsg("Sono consentiti solo file PDF");
            return;
        }

        if (file.size > 15 * 1024 * 1024) {
            setErrorMsg("File troppo grande (max 15MB)");
            return;
        }

        setErrorMsg(null);
        setValue(fieldName, file, { shouldValidate: true });
        uploadFn(file);
    };

    const handleFileSelect = (file) => {
        validateAndUpload(
            file,
            "file",
            uploadSignedPdf
        );
    };
    const handleFileProjectSelect = (file) => {
        validateAndUpload(
            file,
            "fileProject",
            uploadProjectPdf
        );
    };

    const handleDrop = (e) => {
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        handleFileSelect(file);
    };
    const handleProjectDrop = (e) => {
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        handleFileProjectSelect(file);
    };

    const file = watch("file");
    const fileProject = watch("fileProject");

    return (
        <>
        <div className={`offcanvas offcanvas-end ${show ? "show" : ""}`}>
            <div className="offcanvas-header border-bottom">
                <h5 className="offcanvas-title">Carica i file per il contratto {contract ? contract.number.toString().padStart(3, "0") : ""}</h5>
                <button onClick={closeSlide} className="btn-close text-reset"></button>
            </div>
            <div className="offcanvas-body mx-0 flex-grow-0 p-6 h-100">
                {errorMsg && <div className="mb-6 text-center alert alert-outline-danger">{errorMsg}</div>}
                {message && <div className="mb-6 text-center alert alert-outline-success">{message}</div>}
                {(contract.status === "Inviato" || contract.status === "Accettato")
                    && (
                <div className="row">
                    <div className="col-12">
                        <div className="card-body p-4">
                            <form className="dropzone" onSubmit={(e) => e.preventDefault()}>
                                <Controller
                                    name="file"
                                    control={control}
                                    rules={{ required: true }}
                                    render={({ field }) => (
                                        <div className="dz-message" onDrop={handleDrop}
                                            onDragOver={e => e.preventDefault()}
                                            onClick={() => fileInputRef.current.click()}
                                        >
                                            Trascina il file contratto qui o clicca per caricarlo
                                            <input
                                                type="file"
                                                accept=".pdf"
                                                hidden
                                                ref={fileInputRef}
                                                onChange={(e) => {
                                                    const file = e.target.files[0];
                                                    if (file) handleFileSelect(file, field.onChange);
                                                }}
                                            />
                                        </div>
                                    )}
                                />
                                {uploadSignedOK &&
                                    <div className="dz-preview">
                                        <div className="dz-thumbnail alert-outline-success"></div>
                                        <div className="dz-filename">{file ? file.name : ""}</div>
                                        <div className="dz-size"><strong>{file ? (file.size / (1024 * 1024)).toFixed(2) : ""}</strong> MB</div>
                                    </div>
                                }
                            </form>
                        </div>
                    </div>
                </div>
                )}
                <div className="row">
                    <div className="col-12">
                        <div className="card-body p-4">
                            <form className="dropzone" onSubmit={(e) => e.preventDefault()}>
                                <Controller
                                    name="fileProject"
                                    control={control}
                                    rules={{ required: true }}
                                    render={({ field }) => (
                                        <div className="dz-message" onDrop={handleProjectDrop}
                                            onDragOver={e => e.preventDefault()}
                                            onClick={() => fileProjectInputRef.current.click()}
                                        >
                                            Trascina il file progetto qui o clicca per caricarlo
                                            <input
                                                type="file"
                                                accept=".pdf"
                                                hidden
                                                ref={fileProjectInputRef}
                                                onChange={(e) => {
                                                    const file = e.target.files[0];
                                                    if (file) handleFileProjectSelect(file, field.onChange);
                                                }}
                                            />
                                        </div>
                                    )}
                                />
                                {uploadProjectOK &&
                                    <div className="dz-preview">
                                        <div className="dz-thumbnail alert-outline-success"></div>
                                        <div className="dz-filename">{fileProject ? fileProject.name : ""}</div>
                                        <div className="dz-size"><strong>{fileProject ? (fileProject.size / (1024 * 1024)).toFixed(2) : ""}</strong> MB</div>
                                    </div>
                                }
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>

    );
};

export default Upload;